import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { Home, List, Wallet, BookOpen, Menu } from "lucide-react";

export default function BottomNav() {
  const { tripId } = useParams();
  if (!tripId) return null;
  const items = [
    { to: `/trips/${tripId}`, label: "Today", icon: Home, testid: "nav-today", end: true },
    { to: `/trips/${tripId}/itinerary`, label: "Itinerary", icon: List, testid: "nav-itinerary" },
    { to: `/trips/${tripId}/budget`, label: "Budget", icon: Wallet, testid: "nav-budget" },
    { to: `/trips/${tripId}/diary`, label: "Diary", icon: BookOpen, testid: "nav-diary" },
    { to: `/trips/${tripId}/more`, label: "More", icon: Menu, testid: "nav-more" },
  ];
  return (
    <nav data-testid="bottom-nav" className="fixed bottom-0 left-0 right-0 z-30 bg-[color:var(--tcm-cream)] border-t border-[color:var(--tcm-navy-15)]">
      <div className="max-w-2xl mx-auto grid grid-cols-5 px-2 pt-2 pb-6">
        {items.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink key={to} to={to} end={!!end} data-testid={testid}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-1.5 min-h-[48px] text-[11px] uppercase tracking-[0.04em] transition-colors ${isActive ? "text-[color:var(--tcm-navy)]" : "text-[color:var(--tcm-navy-40)]"}`
            }>
            {({ isActive }) => (
              <>
                <span className="w-[18px] h-px mb-[3px]" style={{ background: isActive ? "var(--tcm-gold)" : "transparent" }} />
                <Icon size={21} strokeWidth={1.5} />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
